/**
 * The id the "Not assigned" option writes into the assigned-user filter
 * (LeadFilters and AdvanceFilters). It is not a real member: it asks for
 * leads with no assigned user at all.
 */
export const UNASSIGNED_USER_FILTER_ID = 'NONE';

/**
 * Whether a lead's assigned user passes the assigned-user filter.
 *
 * Live socket events are matched against the same filter the list query
 * uses, so "Not assigned" has to match leads without a user instead of
 * comparing their empty auth id against the literal `NONE`.
 */
export function matchesAssignedUserFilter(
  leadAuthId: string | null | undefined,
  filter: { authId?: string } | null | undefined,
): boolean {
  if (!filter) return true;
  if (filter.authId === UNASSIGNED_USER_FILTER_ID) return !leadAuthId;
  return leadAuthId === filter.authId;
}
